import { Deserializable } from './deserializable.model';
import { Address } from './address.model';
import { PhotographerAppointment } from './photographer-appointment.model';
import { Media } from './media.model';
import { ListingPhoto } from './listing-photo.model';
import { ProductOption } from './product-option.model';
import { PhotoOrderStatus } from './photo-order-types';
import { StateTransition } from './status-history';
import { BrandCode } from './brand.type';
import { PhotographyProvider } from './photography-provider.model';
import { PhotographySource } from './photography-source';

export class PhotoOrder implements Deserializable<PhotoOrder> {
  _id: string;
  photoAgencyId: string;
  photographySource?: PhotographySource;
  catalogVendorId?: string;
  get provider(): PhotographyProvider { return PhotographyProvider.forAppointment(this.appointment); }
  get providerId(): string { return this.catalogVendorId ?? this.provider?.id ?? this.photoAgencyId; }
  get isCatalog(): boolean { return !!(this.catalogVendorId ?? this.appointment?.catalogVendor?.vendorId ?? this.appointment?.photoAgency?.vendorOverrides?.catalog?.vendorId); }
  get mediaOwnerId(): string { return this.catalogVendorId ?? this.photoAgencyId ?? this.providerId; }
  propertyAddress: Address;
  agentName: string;
  orderedAt: Date;
  contactDetails: string;
  appointment: PhotographerAppointment;
  marketingOrderId: string;
  photoOrderId: string;
  status: PhotoOrderStatus;
  media: Media;
  photos: ListingPhoto[] = [];
  options: ProductOption[] = [];
  marketingOrderStatus: string;
  statusHistory: StateTransition[];
  brandCode: BrandCode;

  constructor(input?: any) {
    if (input) {
      this.deserialize(input);
    }
  }

  deserialize(input: any): PhotoOrder {
    Object.assign(this, input);
    this.media = new Media(this.media);
    return this;
  }
}
